<script>
   /***************************************************************
    * Container                                                   *
    * --------------------                                        *
    * a container for any control element                         *
    ***************************************************************/

   export let label = null;   // text label (optional)
   export let status = '';    // class name for status (e.g. 'hidden' or 'error')
</script>

<div class="control-element {status}">
   {#if label}
   <span class="label">{label}</span>
   {/if}
   <slot></slot>
</div>

<style>
   .control-element {
      font-size: 0.85em;
      background: #fff;
      padding: 0.5em 0.75em;
      border-radius: 0;
      display: flex;
      justify-items: center;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.5px;
   }

   .control-element:first-of-type {
      margin-top: 0.25rem;
      border-top-left-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
      margin-bottom: 1px;
   }

   .control-element:last-of-type {
      margin-bottom: 0.25rem;
      border-bottom-left-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
   }

   .hidden {
      display: none;
   }

   .control-element.error {
      background: crimson;
      color: #fefefe;
   }

   .label {
      padding-right: 1em;
      flex-basis: 12ch;
      flex-grow: 0;
      flex-shrink: 1;
      color: #606570;
   }

   .control-element > :global(.wrapper) {
      flex: 1 1;
   }

   .control-element > :global(p) {
      text-align: left;
      flex-grow: 1;
      padding: 0 0.25em;
      margin: 0;
      font-size: 0.9em;
   }

   .control-element > :global(.title) {
      font-size: 1.05em;
      font-weight: bold;
      color: #303540;
      flex-grow: 1;
      padding: 0 0.25em 0 0;
      margin: 0;
   }
</style>